<template>
  <b-modal
    centered
    id="change-source"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Đổi nguồn Merchant</h5>
      <b-button size="sm" variant="light" @click="closeModal()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo" class="m-3">
      <div class="form-group">
        <p>Nguồn merchant</p>
        <Select2
          v-model="source"
          @change="changeSource"
          :options="systemConfig.mcSource"
          placeholder="Nguồn merchant"
        />
      </div>
      <div class="form-group" v-if="source === 'AGENCY'">
        <input type="hidden" class="form-control text-left" v-model="agentSelected" />
        <input
          type="text"
          class="form-control text-left"
          :value="agentSelected.name ? `${agentSelected.name}` : ''"
          placeholder="CTV"
          v-b-modal.select-agent-dialog
        />
      </div>
    </form>
    <template #modal-footer>
      <b-button class="btn-style" size="sm" type="button" variant="light" @click="closeModal()">
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <modalSelectAgent @selectAgent="onSelectAgent" />
  </b-modal>
</template>

<script>
  import modalSelectAgent from '@/pages/merchant/modalSelectAgent.vue'
  export default {
    name: 'modal-edit-mcc',
    props: {
      closeModal: {
        type: Function,
      },
      systemConfig: {
        type: Object,
      },
    },
    data() {
      return {
        showLoading: false,
        source: '',
        agentId: '',
        agentSelected: {},
      }
    },
    components: { modalSelectAgent },
    methods: {
      async updateInfo() {
        const data = {
          source: this.source,
          agentId: '',
        }
        if (this.agentId && this.source === 'AGENCY') data.agentId = this.agentId
        else delete data.agentId
        this.$emit('updateInfo', data)
      },
      onSelectAgent(mc) {
        this.agentSelected = mc
        this.agentId = mc.agentId
      },
      changeSource() {
        this.agentSelected = {}
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
  p {
    font-size: 14px;
  }
</style>
